
class UtilFactory {

	constructor(fechaConfig, $uibModal, moment) {

		this.fechaConfig = fechaConfig;
		this.$uibModal = $uibModal;
		this.moment = moment;
	}

	 convertirFecha (input) {
		if (input == null || input instanceof Date) return input;
		input = input.replace(/-/g, "/").split("/");

		input = new Date(input[1] + "/" + input[0] + "/" + input[2]);

		if (isNaN(input.getDay()) || input.getFullYear() <= 1900) input = null;

		return input;
	 }

	 formatearFecha (fecha) {
	 	return this.moment(fecha).format(this.fechaConfig.FORMATO_FECHA.toUpperCase());
	 }

	 ordenarColeccion(coleccion, campo, descendente) {

	 	if (coleccion == null) return;

	 	var temp = [],
			fecRegex = /\d{2}\/\d{2}\/\d{4}/,
			self = this;
	 	let  insertSort =  (item)=> {
	 		if (temp.length <= 0) {
	 			temp.push(item);
	 			return;
	 		};
	 		var valItem = campo ? _obtenerValorCampo(item, campo) : item;
	 		if (typeof valItem == "string" && valItem.match(fecRegex)) valItem = self.parseDate(valItem);
	 		else if (!isNaN(valItem)) valItem = self.parseNumber(valItem);

	 		for (var i = 0; i < temp.length; i++) {
	 			var valTemp = campo ? _obtenerValorCampo(temp[i], campo) : temp[i];
	 			if (typeof valTemp == "string" && valTemp.match(fecRegex)) valTemp = self.parseDate(valTemp);
	 			else if (!isNaN(valTemp)) valTemp = self.parseNumber(valTemp);

	 			if ((descendente && valItem < valTemp) || (!descendente && valItem > valTemp)) {
	 				if (i < temp.length - 1) continue
	 				temp.push(item);
	 				break;
	 			}
	 			temp.splice(i, 0, item);
	 			break;
	 		}
	 	};
	 	for (var i = 0; i < coleccion.length; i++) {
	 		insertSort(coleccion[i]);
	 	}
	 	return temp;
	 }
	 
	 _obtenerValorCampo(item, campo) {
	 	campo = campo.split(".");
	 	var val = item;
	 	for (var i = 0; i < campo.length; i++) {
	 		if (!val) break;
	 		val = val[campo[i]];
	 	}
	 	return val;
	 }

	  isNullOrEmpty (input) {
	 	return input == null || (input).toString().replace(/\s/g, "").length <= 0;
	  }

	   descargarBase64(data) {

	  	var nombreArchivo = isNullOrEmpty(data.NombreArchivo) ? 'descarga' : data.NombreArchivo;
	  	nombreArchivo += '.' + data.Extension;

	  	if (this._esIE()) {
	  		window.navigator.msSaveOrOpenBlob(this._b64toBlob(data.Base64, data.DataType), nombreArchivo);
	  		return;
	  	}

	  	var url = URL.createObjectURL(this._b64toBlob(data.Base64, data.DataType));

	  	var elem = document.createElement("a");
	  	elem.setAttribute("href", url);
	  	elem.setAttribute("download", nombreArchivo);

	  	elem.style.display = "none";
	  	document.body.appendChild(elem);

	  	elem.click();

	  	document.body.removeChild(elem);
	  }

	  _esIE  () {
	  	var ua = window.navigator.userAgent.toLowerCase();
	  	return ua.indexOf("msie") > -1 || ua.indexOf("trident") > -1 || ua.indexOf("edge") > -1;
	  }

	  _b64toBlob(b64Data, contentType) {
	  	contentType = contentType || '';

	  	var sliceSize = 512;
	  	b64Data = b64Data.replace(/^[^,]+,/, '');
	  	b64Data = b64Data.replace(/\s/g, '');

	  	var byteCharacters = window.atob(b64Data);
	  	var byteArrays = [];

	  	for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
	  		var slice = byteCharacters.slice(offset, offset + sliceSize);

	  		var byteNumbers = new Array(slice.length);
	  		for (var i = 0; i < slice.length; i++) {
	  			byteNumbers[i] = slice.charCodeAt(i);
	  		}

	  		var byteArray = new Uint8Array(byteNumbers);

	  		byteArrays.push(byteArray);
	  	}

	  	var blob = new Blob(byteArrays, { type: contentType });
	  	return blob;

	 }
	 
	  convertirNumero(s) {
	  	var number = Number(s);

	  	if (isNaN(number)) {
	  		number = 0;
	  	}

	  	return number;
	  }
	  
	   mostrarMensaje (msj, aceptarCallback, cancelarCallback) {

	  	this.$uibModal.open({
	  		templateUrl: 'modulos/principal/vistas/informacion-tmpl.html',
	  		controller: ['$uibModalInstance', function (uibModalInstance) {
	  			var vm = this;

	  			vm.mensaje = msj;
	  			vm.aceptar = aceptar;

	  			function aceptar() {
	  				uibModalInstance.close();
	  			}
	  		}],
	  		controllerAs: 'vm',
	  		size: 'md'
	  	})
			.result.then( ()=> {
				if (aceptarCallback) aceptarCallback();
			},  (response) =>{
				if (cancelarCallback) cancelarCallback();
			});
	  }
}

UtilFactory.$inject = ['fechaConfig', '$uibModal', 'moment'];

export default UtilFactory;




// WEBPACK FOOTER //
// ./src/busqueda/servicios/util.factory.js